import {createStyles} from '@mantine/core';

export const useStyles = createStyles(() => ({
	searchInput: {
		width: 188,
	},
	searchWrapper: {
		height: 40,
	},
}));